// @ts-strict-ignore
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import i18n from 'src/utils/translate';
import { LinkButton } from 'styles-js/buttons';
import { Category, useCookieCategory } from 'src/utils/cookie';
import { Emoji } from 'src/constants/types';
const EmojiPicker = dynamic(() => import('src/components/textEditor/components/emojiPicker'), {
  ssr: false,
  loading: () => <LoadingSpinner />
});
type Props = {
  onSelect: (emoji: Emoji) => void;
};
export default function EmojiPickerContainer({
  onSelect
}: Props): JSX.Element {
  const [isFunctionalityAccepted, setIsFunctionalityAccepted] = useCookieCategory(Category.Functionality);
  if (isFunctionalityAccepted === null) return null;
  return <>
      {isFunctionalityAccepted ? <StyledPickerWrapper>
            <EmojiPicker onSelect={onSelect} />
          </StyledPickerWrapper> : <CookieButton onClick={() => setIsFunctionalityAccepted(true)}>
            {i18n.t('Not working? Enable functionality cookies')}
          </CookieButton>}
    </>;
}
const StyledPickerWrapper = styled.div`
  z-index: 1; // show BEHIND mentions portal
`;
const CookieButton = styled(LinkButton)`
  display: block;
  padding: 10px;
`;
const LoadingSpinner = styled.div`
  position: relative;
  width: 30px;
  height: 30px;

  ::after {
    content: '';
    position: relative;
    right: 10px;
    left: -12px;
    width: 60px;
    height: 60px;
    background-image: url("https://images.hu-production.be/static/img/green-spinner.svg");
    background-position: center;
    background-size: cover;
    transform: translate(-50%, -50%);
  }
`;